// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"35117ac3","488":"23dc104a","977":"944e80c9"}[chunkId] + ".chunk.js";
};